import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { BookContext } from '../../context/books';
import "./PresentList.css";
import coverImg from "../../images/cover_not_found.jpg";
import config from '../../aws-exports';

const {
    aws_user_files_s3_bucket_region: region,
    aws_user_files_s3_bucket: bucket
} = config

const Present = (present) => {
    let fotosinjpg = present.nomfoto.split(".jpg")[0];
    const { idioma } = useContext(BookContext);
    switch (idioma) {
      case "español":
    return (
        <div className="present-item flex flex-column flex-sb">
          <Link to = {`/present/id/${present.id}`} {...present}>
            <div className="present-item-img">
                <img src = {present.nomfoto ? `https://${bucket}.s3.${region}.amazonaws.com/fotos/${fotosinjpg}1.jpg` : coverImg} alt = "cover" />
            </div>
          </Link>
            <div className="present-item-info text-center">
                <Link to = {`/present/id/${present.id}`} {...present}>
                    <div className="present-inte-info-item title fw-7 fs-18">
                        <span>{present.titulo}</span>
                    </div>
                </Link>

                <div className="present-inte-info-item author fs-15">
                    <span className="text-capitalized fw-7">Autor: </span>
                    <span>{present.autor}</span>
                </div>
                <div className="present-inte-info-item publish-year fs-15">
                    <span className="text-capitalized fw-7">Fecha del evento: </span>
                    <span>{present.anoevento}</span>
                </div>
                <Link to = {`/present/id/${present.id}`} {...present}>
                <div className="present-inte-info-item author fw-3 fs-09">
                <span className="fw-3 fs-09">(Click para mas datos)</span>
                </div>
                </Link>
            </div>
        </div>
    )
    case "english":
        return (
            <div className="present-item flex flex-column flex-sb">
              <Link to = {`/present/id/${present.id}`} {...present}>
                <div className="present-item-img">
                    <img src = {present.nomfoto ? `https://${bucket}.s3.${region}.amazonaws.com/fotos/${fotosinjpg}1.jpg` : coverImg} alt = "cover" />
                </div>
              </Link>
                <div className="present-item-info text-center">
                    <Link to = {`/present/id/${present.id}`} {...present}>
                        <div className="present-inte-info-item title fw-7 fs-18">
                            <span>{present.titulo}</span>
                        </div>
                    </Link>
    
                    <div className="present-inte-info-item author fs-15">
                        <span className="text-capitalized fw-7">Author: </span>
                        <span>{present.autor}</span>
                    </div>
                    <div className="present-inte-info-item publish-year fs-15">
                        <span className="text-capitalized fw-7">Event's date: </span>
                        <span>{present.anoevento}</span>
                    </div>
                    <Link to = {`/present/id/${present.id}`} {...present}>
                    <div className="present-inte-info-item author fw-3 fs-09">
                    <span className="fw-3 fs-09">(Click for more info)</span>
                    </div>
                    </Link>
                </div>
            </div>
        )
        default:
            break;
    }
}

export default Present;